import Thumbnail from "./thumbnail"
import File from "./file"

export default [
    Thumbnail,
    // File
]
